/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Case_CreatedInputs */

const en_case_history_headline_case_created = /** @type {(inputs: Case_History_Headline_Case_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case created`)
};

const pt_br2_case_history_headline_case_created = /** @type {(inputs: Case_History_Headline_Case_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso criado`)
};

/**
* | output |
* | --- |
* | "Case created" |
*
* @param {Case_History_Headline_Case_CreatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_case_created = /** @type {((inputs?: Case_History_Headline_Case_CreatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Case_CreatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_case_created(inputs)
	return pt_br2_case_history_headline_case_created(inputs)
});